export default __webpack_public_path__ + "static/media/waterheater.756041a2.png";